export const colorBank = [
    {hex: '#002060'},
    {hex: '#0277BD'},
    {hex: '#a7d6ff'},
    {hex: '#3d5afe'},
    {hex: '#138677'},
    {hex: '#00a7b6'},
    {hex: '#3B37E6'},
    {hex: '#3d5afe'},
    {hex: '#6F81CC'},
    {hex: '#138677'},

    {hex: '#6F81CC'},
    {hex: '#a13fb9'},
    {hex: '#5AB963'},
    {hex: '#98efa4'},
    {hex: '#FFF9C4'},
    {hex: '#ba68c8'},
    {hex: '#6A1B9A'},
    {hex: '#0c594f'},
    {hex: '#FFF9C4'},

    {hex: '#f37c70'},
    {hex: '#d8a8e0'},
    {hex: '#af0f5b'},
    {hex: '#ffa800'},
    {hex: '#FE9E00'},
    {hex: '#233591'},
    {hex: '#f48100'},
    {hex: '#FFFFFF'},
    {hex: '#0c0c0c'},
    {hex: '#c63024'}
];
